<template>
  <section class="audio-recoding-submit">
    <header class="title-header">
      <span class="back-btn" @click="goBack()">
        <img src="@/assets/images/ic_back.svg" alt />
      </span>
      <h1 class="header-title" v-if="!uploadBtn">Create News</h1>
      <h1 class="header-title" v-if="uploadBtn">Play News</h1>
    </header>
    <div class="audio-play-block">
      <div class="audio-player">
        <div class="player">
          <audio controls id="myAudio" class="audio">
            <source :src="getAudioData" type="audio/mp3" />
          </audio>
          <div class="wave ">
            <div class="item item-1"></div>
            <div class="item item-2"></div>
            <div class="item item-3"></div>
            <div class="item item-4"></div>
            <div class="item item-5"></div>
            <div class="item item-6"></div>
            <div class="item item-7"></div>
            <div class="item item-8"></div>
            <div class="item item-9"></div>
            <div class="item item-10"></div>
            <div class="item item-11"></div>
            <div class="item item-1"></div>
            <div class="item item-2"></div>
            <div class="item item-3"></div>
            <div class="item item-4"></div>
            <div class="item item-5"></div>
            <div class="item item-6"></div>
          </div>
          <div class="custom-player">
            <span class="current">0:00</span>
            <div class="timeline"  @click="handleProgressClick">
              <div class="progress"></div>
              <!-- <span class="slide-dot progress"></span> -->
            </div>
            <span class="recorded-time"></span>
            <div class="length" style="display: none;"></div>
          </div>
          <div class="controls">
            <div class="play-container">
              <div class="toggle-play" v-if="play" @click="handlePlay">
                <img src="@/assets/images/ic_play.png" alt />
              </div>
              <div class="toggle-play" v-if="!play" @click="handlePlay">
                <img src="@/assets/images/ic_pause.png" alt />
              </div>
            </div>
            <div class="volume-container">
              <div class="volume-button">
                <div class="volume icono-volumeMedium">
                  <img src="@/assets/images/volume.svg" alt />
                </div>
              </div>

              <div class="volume-slider">
                <div class="volume-percentage"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="audio-play-block">
      <div class="player">
        <audio class="audio" controls="controls" id="myAudio" autoplay preload="metadata">
          <source
            type="audio/mpeg"
            src="https://file915a6zxiw5xp.cdn.e2enetworks.net/MiniApp/1ee2e5e34c2886bf91b82adfcea38b4c/223161ce-83bb-4ebb-aee3-344f163c3194.mp3"
          />
        </audio>
        <div class="custom-player">
          <span class="time">04:00</span>
          <div class="play-slide">
            <img src="@/assets/images/dark_full.png" alt />
            <span style="width: 60%;" class="slide-dot"></span>
          </div>
          <span class="recorded-time">00:00</span>
        </div>
        <div class="control-btn">
          <span @click="playAudio()">
            <img src="@/assets/images/ic_play.png" alt />
          </span>
          <span @click="pauseAudio()">
            <img src="@/assets/images/ic_pause.png" alt />
          </span>
        </div>
      </div>
    </div>-->
    <div class="bottom-section">
      <div class="field">
        <label for>News Title</label>
        <input type="text" placeholder="Mall91 News" v-model="newsAudioTitle" :disabled="uploadBtn"/>
      </div>
      <span @click="uploadAudioNews()" v-if="!uploadBtn">अपलोड करे</span>
    </div>
    <div class="submit-popup" v-if="newsUploaded">
      <div class="content">
        <p>आपके न्यूज़ हमारी टीम के पास पहुंच गयी है। हमारी टीम इसे चेक करके लाइव करके आपको पता देगी</p>
        <router-link tag="span" class="ok-btn" :to="{path: '/dashboard'}">OK</router-link>
      </div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="@/assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "@/utils/apicaller";
import constant from "@/utils/constant";
import { SessionHelper, X_AUTH_ID } from "@/utils/session";
import CustomToaster from "@/components/Common/CustomToaster";
import axios from "axios";

export default {
  name: "AudioPreview",
  props: {
    getAudioData: {
      type: String
    },
    clickedNewsData:{
        type: Object
    },
    totalTime:{}
  },
  computed: {},
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      newsUploaded: false,
      recordedTime: "",
      play: false,
      progressBarSecond: 0,
      progressBarInterVal: null,
      newsAudioTitle: '',
      uploadBtn: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    playAudio() {
      let x = document.querySelector(".audio");
      x.play();
    },
    pauseAudio() {
      let x = document.querySelector(".audio");
      x.pause();
    },
    dragStart(event)  {
        event.dataTransfer.setData("Text", event.target.id);
    },
    dragging(event) {
      document.getElementById("demo").innerHTML =
        "The p element is being dragged";
    },
    allowDrop(event) {
      event.preventDefault();
    },
    handleProgressClick(event){
      console.log('=event=',event)
      window.clearInterval(this.progressBarInterVal)
      const timeline = document.querySelector(".timeline");
      const timelineWidth = window.getComputedStyle(timeline).width;
      const timeToSeek =
        (event.offsetX / parseInt(timelineWidth)) * this.totalTime;
        console.log('=time seek=',timeToSeek.toFixed(), timelineWidth, timeToSeek)
      this.progressBarSecond = timeToSeek.toFixed();
      this.handleProgressBarIncrement()
    },
    handleProgressBarIncrement(){
      this.progressBarInterVal = setInterval(() => {
          this.progressBarSecond++
          const progressBar = document.querySelector(".progress");
          const wave = document.querySelector(".wave");
          wave.classList.add("start");
          this.play = true
          if(this.progressBarSecond <= this.totalTime){
            progressBar.style.width = (this.progressBarSecond / this.totalTime) * 100 + "%";
          }
          document.querySelector(".current").textContent = this.getTimeCodeFromNum(
            this.progressBarSecond
          );
          if(this.totalTime === this.progressBarSecond){
            window.clearInterval(this.progressBarInterVal)
            wave.classList.remove("start");
            this.play = false
          }
          console.log('=current=', this.totalTime, this.progressBarSecond)
      }, 1000);
    },
    handlePlay(){
      let audio = document.getElementById('myAudio')
      let wave = document.querySelector(".wave");
      const progressBar = document.querySelector(".progress");
      console.log('=audio=', audio,audio.paused)
      if (audio.paused) {
        console.log('=if=',audio)
          this.play = true;
          audio.play();
          wave.classList.add("start");
          window.clearInterval(this.progressBarInterVal)
          if(this.totalTime === this.progressBarSecond){
            progressBar.style.width = 0 + "%";
            this.progressBarSecond = 0
          }
          this.handleProgressBarIncrement()
        } else {
          console.log('=else=',audio)
          this.play = false;
          audio.pause();
          wave.classList.remove("start");
          window.clearInterval(this.progressBarInterVal)
      } 
    },
     getTimeCodeFromNum(num) {
      let seconds = parseInt(num);
      let minutes = parseInt(seconds / 60);
      seconds -= minutes * 60;
      const hours = parseInt(minutes / 60);
      minutes -= hours * 60;
      if (hours === 0)
        return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
      return `${String(hours).padStart(2, 0)}:${minutes}:${String(
        seconds % 60
      ).padStart(2, 0)}`;
    },
    uploadAudioNews(){
      this.loading = true
      const obj = {
        task_id: this.$route.query.allTaskIndex,
        news_title: this.newsAudioTitle,
        news: this.getAudioData,
        news_type: 'mp3'
      }
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/submit_news/",
        "post",
        obj
      )
        .then(data => {
          if(data.success){
            this.$router.replace('/uploaded-news')
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  mounted() {
    // Possible improvements:
    // - Change timeline and volume slider into input sliders, reskinned
    // - Change into Vue or React component
    // - Be able to grab a custom title instead of "Music Song"
    // - Hover over sliders to see preview of timestamp/volume change
    console.log('===', this.totalTime, this.$props, this.clickedNewsData)
    const audioPlayer = document.querySelector(".audio-player");
    const audio = new Audio(this.getAudioData);
    //credit for song: Adrian kreativaweb@gmail.com
    if(this.clickedNewsData && this.clickedNewsData.news_title){
      this.newsAudioTitle = this.clickedNewsData.news_title
      this.uploadBtn = true
    }
  
    //click volume slider to change volume
    const volumeSlider = audioPlayer.querySelector(".controls .volume-slider");
    volumeSlider.addEventListener(
      "click",
      e => {
        const sliderWidth = window.getComputedStyle(volumeSlider).width;
        const newVolume = e.offsetX / parseInt(sliderWidth);
        audio.volume = newVolume;
        audioPlayer.querySelector(".controls .volume-percentage").style.width =
          newVolume * 100 + "%";
      },
      false
    );

    //check audio percentage and update time accordingly
   

    //toggle between playing and pausing on button click
    var playBtn = audioPlayer.querySelector(".toggle-play img");
    const wave = audioPlayer.querySelector(".wave");
    audioPlayer
      .querySelector(".volume-button")
      .addEventListener("click", () => {
        const volumeEl = audioPlayer.querySelector(".volume-container .volume");
        audio.muted = !audio.muted;
        if (audio.muted) {
          volumeEl.classList.remove("icono-volumeMedium");
          volumeEl.classList.add("icono-volumeMute");
        } else {
          volumeEl.classList.add("icono-volumeMedium");
          volumeEl.classList.remove("icono-volumeMute");
        }
      });

      
    document.querySelector(".recorded-time").textContent = this.getTimeCodeFromNum(this.totalTime)
   }

};
</script>

<style scoped lang="scss">
html {
  background: black;
}

.wave {
  position: relative;
  // margin: 200px;
  top: 0;
}
.wave{
  width: 94%;
  display: flex;
  align-items: flex-end;
  // justify-content: space-between;
  justify-content: center;
  height: 160px;
  &.start{
    .item-1{
      animation:Animation 1.9s linear infinite;
    }
    .item-2{
      animation:Animation 1.5s linear infinite;
    }
    .item-3{
      animation:Animation 2.5s linear infinite;
    }
    .item-4{
      animation:Animation 2s linear infinite;
    }
    .item-5{
      animation:Animation 1s linear infinite;
    }
    .item-6{
      animation:Animation 2.9s linear infinite;
    }
    .item-7{
      animation:Animation 1.7s linear infinite;
    }
    .item-8{
      animation:Animation 1.2s linear infinite;
    }
    .item-9{
      animation:Animation 2.7s linear infinite;
    }
    .item-10{
      animation:Animation 2.4s linear infinite;
    }
    .item-11{
      animation: Animation 1.2s linear infinite;
    }
  }
  .item{
    width: 5px;
    height: 40px;
    background: #000;
    margin: 0 4px;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes Animation {
    50%{
      background: #bd67bf;
      height: 80px;
    }
  }
}

.audio-recoding-submit .audio-play-block .player .audio {
  /* display: block; */
}
body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(to bottom right, #b968c5, skyblue);
}
.controls {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 0 20px;

  > * {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.audio-player {
  height: 300px;
  width: 350px;
  // background: #444;
  // box-shadow: 0 0 20px 0 #000a;

  font-family: arial;
  color: white;
  font-size: 0.75em;
  overflow: hidden;

  display: grid;
  grid-template-rows: 6px auto;
  .timeline {
    background: white;
    width: 100%;
    position: relative;
    height: 2px;
    cursor: pointer;
    box-shadow: 0 2px 10px 0 #0008;
    .progress {
      background: #7a7a7a;
      width: 0%;
      height: 100%;
      transition: 0.25s;
      position: absolute;
      left: 0;
      &::before {
        content: "";
        position: absolute;
        right: -6px;
        bottom: -5px;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        background: #bd67bf;
      }
    }
  }
  .play-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    // padding-top: 24px;
    .toggle-play {
      margin: 8px;
      transition: all 0.2s;
      img {
        height: 50px;
        box-shadow: 0 10px 18px 4px #fcb7fba3;
        border-radius: 50%;
      }
    }
  }
  .volume-container {
    cursor: pointer;
        height: 30px;
            padding-right: 16%;
    padding-top: 10%;
    &:focus{
        outline: none;
      }
    .volume-button {
      height: 26px;
      display: flex;
      align-items: center;
      
      .volume {
        transform: scale(0.7);
        height: 40px;
        width: 40px;
        &:focus{
        outline: none;
      }
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

    position: relative;
    z-index: 2;
    .volume-slider {
      position: absolute;
      left: -3px;
      top: 0;
      z-index: -1;
      width: 0;
      height: 8px;
      background: white;
      box-shadow: 0 0 20px #000a;
      transition: 0.25s;
      .volume-percentage {
        background: #bd67bf;
        height: 100%;
        width: 75%;
      }
    }
    &:hover {
      .volume-slider {
        left: -85px;
        width: 120px;
      }
    }
  }
}
</style>
